import React from 'react';
import PageHeader from './Header/Header';

const AdminTopBar = () => {
  return <PageHeader />;
};

export default AdminTopBar;
